module.exports = __webpack_public_path__ + "static/img/rank_62.a8a6131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_62.png
// module id = YIuB
// module chunks = 1